// extracted by mini-css-extract-plugin
export default {"scanZone":"ScanArea_scanZone__a9aMP","iconWrapper":"ScanArea_iconWrapper__TEHVL","title":"ScanArea_title__sMf-J","subtitle":"ScanArea_subtitle__C2+46"};